import { numberToCurrency } from '@hc-frontend/utils'

export default function toMoney(value: number) {
  return numberToCurrency(value, false)
}
